<template>
    <div class="date_range_picker">
        <button class="picker" @click="openDatePicker()">
            <span class="dates">{{ datesString }}</span>
            <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M0.25 11.6526V5.94287H13.75V11.6984C13.75 14.0526 12.2681 15.5001 9.89709 15.5001H4.0955C1.74671 15.5001 0.25 14.0226 0.25 11.6526ZM3.96924 9.8075C3.62841 9.82325 3.34685 9.5525 3.33203 9.20825C3.33203 8.86325 3.59877 8.57825 3.93961 8.5625C4.27303 8.5625 4.54718 8.82575 4.55459 9.1625C4.56941 9.50825 4.30267 9.79325 3.96924 9.8075ZM7.01465 9.8075C6.67382 9.82325 6.39226 9.5525 6.37744 9.20825C6.37744 8.86325 6.64418 8.57825 6.98502 8.5625C7.31844 8.5625 7.59259 8.82575 7.6 9.1625C7.61482 9.50825 7.34808 9.79325 7.01465 9.8075ZM10.038 12.5676C9.69715 12.5601 9.423 12.2751 9.423 11.9301C9.41559 11.5851 9.68974 11.3008 10.0306 11.2933H10.038C10.3862 11.2933 10.6678 11.5783 10.6678 11.9301C10.6678 12.2826 10.3862 12.5676 10.038 12.5676ZM6.37744 11.9301C6.39226 12.2751 6.67382 12.5458 7.01465 12.5301C7.34808 12.5158 7.61482 12.2308 7.6 11.8858C7.59259 11.5483 7.31844 11.2851 6.98502 11.2851C6.64418 11.3008 6.37744 11.5851 6.37744 11.9301ZM3.32471 11.9301C3.33953 12.2751 3.62108 12.5458 3.96192 12.5301C4.29534 12.5158 4.56208 12.2308 4.54726 11.8858C4.53986 11.5483 4.26571 11.2851 3.93228 11.2851C3.59145 11.3008 3.32471 11.5851 3.32471 11.9301ZM9.43018 9.20074C9.43018 8.85574 9.69692 8.57824 10.0378 8.57074C10.3712 8.57074 10.6379 8.83999 10.6527 9.17074C10.6601 9.51574 10.3934 9.80074 10.06 9.80749C9.71914 9.81499 9.43758 9.55249 9.43018 9.20824V9.20074Z" fill="var(--accent-bg)"/>
              <path opacity="0.4" d="M0.253906 5.94268C0.263539 5.50243 0.300586 4.62868 0.370234 4.34743C0.725888 2.76568 1.93363 1.76068 3.66003 1.61743H10.3433C12.0549 1.76818 13.2775 2.77993 13.6331 4.34743C13.702 4.62118 13.7391 5.50168 13.7487 5.94268H0.253906Z" fill="var(--accent-bg)"/>
              <path d="M4.22873 3.9425C4.55475 3.9425 4.79926 3.69575 4.79926 3.365V1.07825C4.79926 0.7475 4.55475 0.5 4.22873 0.5C3.90271 0.5 3.6582 0.7475 3.6582 1.07825V3.365C3.6582 3.69575 3.90271 3.9425 4.22873 3.9425" fill="var(--accent-bg)"/>
              <path d="M9.76975 3.9425C10.0884 3.9425 10.3403 3.69575 10.3403 3.365V1.07825C10.3403 0.7475 10.0884 0.5 9.76975 0.5C9.44373 0.5 9.19922 0.7475 9.19922 1.07825V3.365C9.19922 3.69575 9.44373 3.9425 9.76975 3.9425" fill="var(--accent-bg)"/>
            </svg>

        </button>
        <div class="date_picker_wrapper">
            <DatePicker
              :key="pickerKey"
              v-model="initialDates"
              :language="lang"
              :apply-button-label="text('common.actions.select')"
              :reset-button-label="text('common.actions.cancel')"
              @date-applied="selectDates"
            />
        </div>
    </div>
</template>

<script>
import { DatePicker, CalendarDialog } from 'vue-time-date-range-picker'

export default {
    components: {
      DatePicker,
      CalendarDialog
    },
    data () {
        return {
            pickerKey: new Date().getTime(),
            pickerOptions: {},
            initialDates: [ new Date(new Date().setMonth(new Date().getMonth() - 1)), new Date() ],
            showHelperButtons: true
        }
    },
    props: {
      modelValue: {
        type: Array,
        default: () => ([])
      },
    },
    watch: {
      initialDates: {
        handler: function () {
          this.markRangeEnds()
        },
        deep: true
      }
    },
    computed: {
      datesString({ modelValue }) {
        if (!modelValue) return

        const checkDatesInSameYear =(startDate, endDate)=> {
          const start = new Date(startDate);
          const end = new Date(endDate);

          const startYear = start.getFullYear();
          const endYear = end.getFullYear();

          // Если год начальной даты равен году конечной,
          // то обе даты принадлежат одному году.
          return startYear === endYear;
        }

        const datesWithSameYear = checkDatesInSameYear(modelValue[0], modelValue[1])

        let start, end

        if (datesWithSameYear) {
          const formatter = new Intl.DateTimeFormat(`${this.lang === 'ru' ? 'ru-RU' : 'en-US'}`, {
            day: 'numeric',
            month: 'long',
          });

          start = formatter.format(modelValue[0]);
          end = formatter.format(modelValue[1]);
        } else {
          const formatter = new Intl.DateTimeFormat(`${this.lang === 'ru' ? 'ru-RU' : 'en-US'}`, {
            day: 'numeric',
            month: 'short',
            year: 'numeric'
          });

          start = formatter.format(modelValue[0]);
          end = formatter.format(modelValue[1]);
        }


        return `${start} - ${end}`
      }
    },
    methods: {
        markRangeEnds() {
          this.$nextTick(() => {
            const highlighted = document.querySelectorAll('.vdpr-datepicker__calendar-table tbody .highlighted')
            if (highlighted.length) {
              highlighted[0].classList.add('highlighted_first')
              highlighted[highlighted.length - 1].classList.add('highlighted_last')
            }
          })
        },
        selectDates (start, end) {
          this.$emit('update:modelValue', [start, end])
        },
        openDatePicker () {            
            $('.vdpr-datepicker input[type="text"]').click();
            $('.date_picker_wrapper').addClass('active')
        },
        initListeners() {
          this.$emit('update:modelValue', this.initialDates)

          let prev = `<`;
          let next = `>`;
          $('.vdpr-datepicker__calendar-control-prev').append(prev);
          $('.vdpr-datepicker__calendar-control-next').append(next);
          $('.vdpr-datepicker__calendar-table th').each(function (idx, el) {
            $(el).text($(el).text()[0]);
          });

          function sortClass () {
            if ($('.vdpr-datepicker__calendar-table tbody .highlighted').length == 1) {
              $($('.vdpr-datepicker__calendar-table tbody .highlighted')[0]).addClass('highlighted_one');
            } else if ($('.vdpr-datepicker__calendar-table tbody .highlighted').length > 1) {
              $($('.vdpr-datepicker__calendar-table tbody .highlighted')[0]).removeClass('highlighted_one').addClass('highlighted_first');
              $($('.vdpr-datepicker__calendar-table tbody .highlighted')[$('.vdpr-datepicker__calendar-table tbody .highlighted').length - 1]).addClass('highlighted_last');
            }
          }

          $('.vdpr-datepicker__calendar-control-prev').click(() => sortClass())
          $('.vdpr-datepicker__calendar-control-next').click(() => sortClass())
          $('.vdpr-datepicker__calendar-table tbody td').click(() => sortClass())

          const resetBtn = document.querySelector('.vdpr-datepicker__button-reset')
          resetBtn.addEventListener('click', (event) => {
            event.stopPropagation() // запрещаем стандартной кнопке reset работать как она работала и делаем ее cancel кнопкой

            this.initialDates = []
            this.modelValue.forEach((date, index) => {
              this.initialDates[index] = date
            })

            $('.vdpr-datepicker input[type="text"]').click();
            $('.date_picker_wrapper').removeClass('active')

            this.pickerKey = new Date().getTime()
            this.$nextTick(() => {
              this.initListeners()
            })
          }, true)


          $('.date_range_picker .vdpr-datepicker__button-submit').click(function () {
            $('.date_picker_wrapper').removeClass('active')
          })

          this.markRangeEnds()
        }
    },
    mounted () {
      this.initListeners()
    }
}
</script>

<style>
  .date_range_picker {
    .picker {
      display: flex;
      align-items: center;
      gap: 7px;
      .dates {
        font-size: 18px;
        font-weight: 500;
        color: var(--text-color-accent);
      }
    }
  }

  .date_range_picker .vdpr-datepicker input[type=text] {
    display: none;
  }
  .date_range_picker .vdpr-datepicker__calendar-dialog {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    min-width: 290px;

    border-radius: 24px;
    box-shadow: 0 4px 8px 0 rgba(5, 27, 68, 0.08);
    background-color: var(--layout-bg);
    margin-top: 20px;
    padding: 0;
    display: flex;
    flex-direction: row;
    z-index: 2;
    overflow: hidden;
  }
  .date_range_picker .vdpr-datepicker__calendar-button-helper {
    display: none;
  }
  .date_range_picker .vdpr-datepicker__button-default {
    background: transparent;
    border: none;
    color: #696F8C;
    font-feature-settings: "clig" off, "liga" off;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: -0.5px;
    padding: 4px 20px;
    margin: 0;
    text-align: left;
  }
  .date_range_picker .vdpr-datepicker__calendar {
    width: 100%;
  }
  .date_range_picker .vdpr-datepicker__calendar-control {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px;
    gap: 12px;
  }
  .date_range_picker .vdpr-datepicker__calendar-control-prev,
  .date_range_picker .vdpr-datepicker__calendar-control-next {
    border-radius: 4px;
    background: var(--element-bg);
    position: relative;
    padding: 0;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .date_range_picker .vdpr-datepicker__calendar-control-prev::before,
  .date_range_picker .vdpr-datepicker__calendar-control-next::before {
    display: none;
  }
  .date_range_picker .vdpr-datepicker__calendar-month-year {
    text-transform: none;
    text-align: center;
    color: var(--text-color-primary);
    font-feature-settings: "clig" off, "liga" off;
    font-family: "Inter", sans-serif;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: -0.5px;
  }
  .date_range_picker .vdpr-datepicker__calendar-table {
    width: 100%;
    border-spacing: 0;
    padding: 12px;
    margin-bottom: 64px;
  }
  .date_range_picker .vdpr-datepicker__calendar-table th {
    color: #8F95B2;
    font-feature-settings: "clig" off, "liga" off;
    font-family: "Inter", sans-serif;
    font-size: 10px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px;
    letter-spacing: -0.2px;
    width: 36px;
    padding: 0 0 8px;
  }
  .date_range_picker .vdpr-datepicker__calendar-table td {
    width: 36px;
    height: 32px;
    text-align: center;
    color: var(--text-color-primary);
    font-feature-settings: "clig" off, "liga" off;
    font-family: "Inter", sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: -0.5px;
    background: transparent;
  }
  .date_range_picker .vdpr-datepicker__calendar-table .faded {
    color: var(--text-color-secondary);
  }
  .date_range_picker .vdpr-datepicker__calendar-table .highlighted {
    background: var(--element-bg);
    color: #FFFFFF;
  }
  .date_range_picker .vdpr-datepicker__calendar-table .highlighted_one {
    border-radius: 4px;
    background: var(--accent-bg);
    color: #FFFFFF;
  }
  .date_range_picker .vdpr-datepicker__calendar-table .highlighted_first {
    border-radius: 4px 0 0 4px;
    background: var(--accent-bg);
    color: #FFFFFF;
  }
  .date_range_picker .vdpr-datepicker__calendar-table .highlighted_last {
    border-radius: 0 4px 4px 0;
    background: var(--accent-bg);
    color: #FFFFFF;
  }
  .date_range_picker .vdpr-datepicker__calendar-input-wrapper {
    display: none;
    width: 0;
  }
  .date_range_picker .vdpr-datepicker__calendar-actions {
    width: 0;
    padding: 0;
  }
  .date_range_picker .vdpr-datepicker__button-reset {
    position: absolute;
    padding: 0;
    bottom: 12px;
    left: 12px;
    border-radius: 8px;
    border: 1px solid var(--element-bg);
    background: var(--element-bg);
    width: 108px;
    height: 40px;
    color: #A6A4B4;
    font-feature-settings: "clig" off, "liga" off;
    font-family: "Rubik", sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: -0.5px;
  }
  .date_range_picker .vdpr-datepicker__button-submit {
    padding: 0;
    width: 99px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    background: var(--accent-bg);
    border: none;
    color: #262329;
    font-family: "Rubik", sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    position: absolute;
    right: 12px;
    bottom: 12px;
  }
</style>
